import { PdfHighlight, HighlightRect } from '../@types/Acertei';
import Service from './Service';

class PdfHighlightService extends Service {
  private static normalize(h: any): PdfHighlight {
    return {
      highlight_id: h.highlight_id || h.ID || '',
      pdf_doc_id: h.pdf_doc_id || (h.PdfDocID ?? ''),
      question_id: h.question_id || h.QuestionID,
      pdf_title: h.pdf_title,
      file_key: h.file_key,
      page: h.page ?? h.Page ?? 1,
      rect: h.rect || h.Rect,
      reviewed: h.reviewed ?? h.Reviewed ?? false,
    };
  }

  static getByQuestion(questionId: string) {
    return this.Http.get<any>(`/pdf-highlights/by-question/${questionId}`)
      .then(this.getData)
      .then(h => (h ? PdfHighlightService.normalize(h) : null));
  }

  static getByPdf(pdfDocId: string) {
    return this.Http.get<any[]>(`/pdf-highlights/by-pdf/${pdfDocId}`)
      .then(this.getData)
      .then(arr => (arr ?? []).map(PdfHighlightService.normalize));
  }

  static create(payload: { pdf_doc_id: string; question_id: string; page: number; rect: HighlightRect }) {
    return this.Http.post<{ highlight_id: string }>('/pdf-highlights', payload).then(this.getData);
  }

  static update(id: string, payload: { page: number; rect: HighlightRect; reviewed?: boolean }) {
    return this.Http.put(`/pdf-highlights/${id}`, payload).then(this.getData);
  }

  static delete(id: string) {
    return this.Http.delete(`/pdf-highlights/${id}`).then(this.getData);
  }
}

export default PdfHighlightService;
